import { takeLatest, call, put } from "redux-saga/effects";
import {
  FETCH_CANDIDATE_DETAILS_REQUEST,
} from "../../actionTypes";

import {
  fetchCandidateDetailSuccess,
  fetchCandidateDetailFailure,
} from "./actions";
import AxiosInstance from "../../../services/AxiosInstance";
// Worker saga
function* fetchCandidateDetailaction(action) {
  try {
    const response = yield call(() =>
      AxiosInstance().post("/recruiter/jobseeker_basic_info", action.payload)
    );
    console.log("response77", response);
    if (response.status) {
      yield put(fetchCandidateDetailSuccess(response.data));
    } else {
      fetchCandidateDetailFailure(response.message);
    }
  } catch (error) {
    yield put(
      fetchCandidateDetailFailure({ status: false, message: error.message })
    );
  }
}

// Watcher saga
function* fetchCandidateDetailSaga() {
  yield takeLatest(FETCH_CANDIDATE_DETAILS_REQUEST, fetchCandidateDetailaction);
}
export default fetchCandidateDetailSaga;
